import React from 'react';
import { useAuth } from '@store/authStore';
import HolidayList from '@pages/employee/HolidayList';
import AdminHolidayList from '@pages/admin/AdminHolidayList';
import PMHolidayList from '@pages/programManager/HolidayList';
import HRHolidayList from '@pages/hr/HRHolidayList';

const HolidayRouter: React.FC = () => {
  const { user } = useAuth();

  console.log('HolidayRouter: User role:', user?.role);

  // Render holiday list based on user role
  if (user?.role === 'Admin') {
    console.log('HolidayRouter: Rendering Admin Holiday List');
    return <AdminHolidayList />;
  }

  if (user?.role === 'HR') {
    console.log('HolidayRouter: Rendering HR Holiday List');
    return <HRHolidayList />;
  }

  if (user?.role === 'Employee') {
    console.log('HolidayRouter: Rendering Employee Holiday List');
    return <HolidayList />;
  }

  if (user?.role === 'Program Manager') {
    console.log('HolidayRouter: Rendering Program Manager Holiday List');
    return <PMHolidayList />;
  }

  // Default to Employee view for unknown roles
  console.log('HolidayRouter: Rendering default Employee Holiday List');
  return <HolidayList />;
};

export default HolidayRouter;
